<template>
    <div>
        <b-modal
            @shown="onModalShown"
            @hidden="onModalHidden"
            @hide="beforeModalHidden"
            id="createPaymentModal"
            ref="createPaymentModal"
            :lazy="true"
            :title="title"
            no-close-on-backdrop
            no-close-on-esc
            title-tag="h2"
            :hide-header-close="hideHeaderClose"
        >
            <template v-slot:modal-header="{ close }" v-if="isPayNow">
                <div class="custom-header">
                    <i class="cus-lock" />
                    <h2 class="modal-title">
                        Secure Payment
                    </h2>
                </div>
                <button
                    v-if="!showDontRefreshMsg"
                    type="button"
                    aria-label="Close"
                    class="close"
                    @click="close()"
                >
                    ×
                </button>
            </template>

            <InvoiceInPaymentWarning
                v-if="selectedInvoicesId && selectedInvoicesId.length > 0"
                :invoiceIds="module === 'invoice' ? [] : selectedInvoicesId"
                :invoiceId="module === 'invoice' && invoice ? invoice.id : null"
                :module="module"
            />

            <b-alert
                v-if="isPayNow"
                variant="danger"
                :dismissible="false"
                :show="payment_data.myerror !== ''"
            >
                <i class="cus-exclamation" /> {{ payment_data.myerror }}
            </b-alert>

            <b-alert
                v-if="isPayNow"
                variant="warning"
                :show="payment_data.overpaidMsg !== ''"
            >
                {{ payment_data.overpaidMsg }}
            </b-alert>

            <div
                v-if="showPendingCubexItemAlert"
                class="alert alert-warning ss"
                role="alert"
            >
                There are pending item(s) to be processed. Submitting payment
                with pending item(s) will cancel the order of the item(s).
            </div>

            <!-- Modal Form -->
            <create
                v-show="page == 'create'"
                ref="create"
                :data.sync="payment_data"
                :is-pay-now="isPayNow"
                class="pl-2"
                @update="updateData"
                @loading="loading = true"
                @loaded="loading = false"
                @invoice-changed="triggerEmitSocketInvoiceChanged"
            />
            <payment-method-option
                v-if="page == 'payment-selection'"
                :data="payment_data"
                @loading="loading = true"
                @loaded="loading = false"
            />
            <payment
                v-if="page == 'payment'"
                ref="payment"
                :data="payment_data"
                class="pl-2"
                @loading="loading = true"
                @loaded="loading = false"
                @disableSaveButton="disabledSaveButton"
                @intentLoading="reloadPaymentIntent"
                @save="verifyGravityPayment"
                @save-gravity="savePayNow"
                :showSignaturePad="showSignaturePad"
                :showSaveCardOption="showSaveCardOption"
                :isFixedAmount="payment_data.isFixedAmount"
                :isPayNow="isPayNow"
            />

            <div
                v-if="isPayNow && showDontRefreshMsg"
                class="text-center my-2 alert alert-warning"
            >
                Please do not refresh your browser<br />or exit this page while
                your payment is being processed.
            </div>

            <div slot="modal-footer" class="w-100">
                <b-btn
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    @click="$refs.createPaymentModal.hide()"
                    >Cancel</b-btn
                >
                <div v-if="loading">
                    <b-btn
                        v-if="
                            _checkPaymentName(
                                _.get(
                                    payment_data,
                                    'payment_type_object.name',
                                    ''
                                ),
                                'terminal',
                                'gravity'
                            ) &&
                            saving &&
                            !cancelling
                        "
                        class="float-left"
                        variant="secondary"
                        @click="cancelOperation"
                        >Cancel
                    </b-btn>
                    <b-btn
                        v-if="
                            _checkPaymentName(
                                _.get(
                                    payment_data,
                                    'payment_type_object.name',
                                    ''
                                ),
                                'terminal',
                                'stripe'
                            ) &&
                            saving &&
                            !cancelling &&
                            stripeTerminal !== null
                        "
                        class="float-left"
                        variant="secondary"
                        @click="resetStripeTerminal"
                        >Cancel
                    </b-btn>
                    <div class="float-right" style="margin-top: 0.5rem;">
                        <span
                            v-if="
                                _.get($refs, 'create.is_cc_terminal') &&
                                saving &&
                                !cancelling
                            "
                            >Processing payment</span
                        >
                        <span
                            v-if="
                                _.get($refs, 'create.is_cc_terminal') &&
                                cancelling
                            "
                            >Cancelling</span
                        >
                        <span
                            ><img
                                v-if="loading"
                                class="float-right"
                                src="assets/ajax-loader.gif"
                        /></span>
                    </div>
                </div>
                <div
                    v-else-if="isPayNow && page === 'payment-selection'"
                    class="float-right"
                >
                    <div v-if="payment_data.credit_card_processor == 'STRIPE'">
                        <img
                            v-if="isIntentLoading"
                            class="float-right"
                            src="assets/ajax-loader.gif"
                            style="margin-top: 0.5rem;"
                        />
                        <b-btn
                            v-else
                            variant="primary"
                            @click="page = 'payment'"
                        >
                            Next
                        </b-btn>
                    </div>
                </div>
                <div
                    v-else-if="isPayNow && page === 'payment'"
                    class="float-right"
                >
                    <b-btn
                        v-if="payment_data.credit_card_processor === 'GRAVITY'"
                        variant="primary"
                        :disabled="
                            payment_data.credit_card_name_on_card == '' ||
                            isHasUsersChooseInvoice
                        "
                        id="save-btn"
                        @click="
                            payment_data.payNowGravityStep === 1
                                ? checkInvoiceStatus()
                                : null
                        "
                    >
                        {{
                            payment_data.payNowGravityStep === 1
                                ? "Continue"
                                : "Pay Now"
                        }}
                    </b-btn>
                    <div
                        v-else-if="
                            payment_data.credit_card_processor == 'STRIPE'
                        "
                    >
                        <img
                            v-if="isIntentLoading"
                            class="float-right"
                            src="assets/ajax-loader.gif"
                            style="margin-top: 0.5rem;"
                        />
                        <b-btn
                            v-else
                            variant="primary"
                            :disabled="
                                isDisabledButton || isHasUsersChooseInvoice
                            "
                            id="save-btn"
                            @click="checkInvoiceStatus"
                        >
                            Pay Now
                        </b-btn>
                    </div>
                    <b-btn
                        v-else-if="
                            payment_data.credit_card_processor !== 'GRAVITY'
                        "
                        variant="primary"
                        id="save-btn"
                        @click="checkInvoiceStatus"
                        :disabled="isHasUsersChooseInvoice"
                    >
                        Pay Now
                    </b-btn>
                </div>
                <div v-else class="float-right">
                    <!-- <b-btn variant="primary" @click="save">Save</b-btn> -->
                    <b-btn
                        v-if="page !== 'create'"
                        variant="primary"
                        @click="back"
                        >Back</b-btn
                    >&nbsp;
                    <b-btn
                        v-if="
                            page == 'create' &&
                            _.get(
                                payment_data,
                                'payment_type_object.name',
                                ''
                            ).includes('Keyed-in')
                        "
                        variant="primary"
                        @click="checkInvoiceStatus"
                        :disabled="isHasUsersChooseInvoice"
                        >Next</b-btn
                    >
                    <b-btn
                        v-else-if="
                            page == 'create' &&
                            _.get($refs, 'create.is_cc_card_in')
                        "
                        variant="primary"
                        @click="checkInvoiceStatus"
                        :disabled="isHasUsersChooseInvoice"
                        >Next</b-btn
                    >
                    <b-btn
                        v-else-if="
                            page == 'create' &&
                            _.get($refs, 'create.is_stripe_acss')
                        "
                        variant="primary"
                        @click="checkInvoiceStatus"
                        :disabled="isHasUsersChooseInvoice"
                        >Proceed</b-btn
                    >
                    <b-btn
                        v-else-if="
                            page == 'payment' &&
                            _.get($refs, 'create.is_gravity_key_in')
                        "
                        variant="primary"
                        id="save-btn"
                        :disabled="isHasUsersChooseInvoice"
                        >Save</b-btn
                    >
                    <b-btn
                        v-else-if="page == 'payment'"
                        variant="primary"
                        :disabled="isDisabledButton || isHasUsersChooseInvoice"
                        @click="saveCreditCard"
                        >Save</b-btn
                    >
                    <b-btn
                        v-else
                        :disabled="
                            (_.get($refs, 'create.is_cc_terminal') &&
                                _.get($refs, 'create.is_no_terminal')) ||
                            isHasUsersChooseInvoice
                        "
                        variant="primary"
                        @click="checkInvoiceStatus"
                        >Save</b-btn
                    >
                </div>
            </div>
        </b-modal>
        <credit-convert-confirmation
            ref="credit-convert-confirmation"
            @cancel-payment="$refs.createPaymentModal.hide()"
            @not-confirmed="notConfirmed"
            @proceed-payment="proceedSave"
        />
        <PaymentAuthentication
            ref="paymentAuthentication"
            @onComplete3ds="onComplete3ds"
        ></PaymentAuthentication>
    </div>
</template>

<style scoped>
.custom-header {
    display: grid;
    grid-template-columns: 30px 1fr;
    align-items: center;
    flex: 1;
}
</style>

<script>
import { get, merge, map, some, filter, isEmpty } from "lodash";
import Create from "@/components/new-payment/payment-create.vue";
import Payment from "@/components/new-payment/payment-process.vue";
import PaymentMethodOption from "@/components/new-payment/payment-method-option.vue";
import PaymentDialogHelper from "@/module/payment/helper.js"; //TODO: need to move to helper folder
import ScheduleHelper from "@/module/schedule/helper"; //TODO: need to move to helper folder
import PaymentInvoiceSocketMixin from "@/mixins/payment-invoice-socket";
import uuidv4 from "uuid/v4";
import CreditConvertConfirmation from "@/components/new-payment/credit-convert-confirmation";
import PaymentService from "@/services/payment.js";
import PaymentAuthentication from "@/components/new-payment/payment-authentication.vue";
import PaymentType from "@/constants/payment-type";
import InvoiceInPaymentWarning from "@/components/invoice/invoice-in-payment-warning";
import joinPaymentInvoiceSocket from "@/mixins/join-payment-invoice-socket.js";
import unsavePrompt from "@/mixins/unsave-prompt.js";
import EXTENSIONS from "@/constants/extensions";
import CubexService from "@/services/setting/cubex";

const INVOICE_STATUS_PAID = 2;
export default {
    name: "NewPaymentModal",
    components: {
        Create,
        Payment,
        PaymentMethodOption,
        CreditConvertConfirmation,
        PaymentAuthentication,
        InvoiceInPaymentWarning
    },
    mixins: [
        ScheduleHelper,
        PaymentDialogHelper,
        PaymentInvoiceSocketMixin,
        joinPaymentInvoiceSocket,
        unsavePrompt
    ],
    props: {
        client: {
            default: null
        },
        invoice: {
            default: null
        },
        module: {
            type: String,
            required: false,
            default: "payment-modal"
        }
    },
    data() {
        return {
            page: "create",
            title: "New Payment",
            loading: false,
            saving: false,
            cancelling: false,
            isDisabledButton: false,
            isIntentLoading: false,
            open_time: null,
            payment_data: {
                id: null,
                checkout_date: null,
                invoicesList: [],
                start: null,
                client: null,
                client_id: null,
                client_email: null,
                client_fax: null,
                credit_amount: 0,
                credits: [],
                selectedCreditsTotal: 0,
                change: "0",
                creditsList: [],
                currency_symbol: null,
                documents: [],
                documentsList: [],
                export_message: null,
                invoice_amount: 0,
                invoices: [],
                selectedInvoicesTotal: 0,
                outstanding_amount: 0,
                payment_amount: "0.00",
                patient_id: null,
                stripeToken: null,
                provider_id: null,
                rabies_tag: null,
                reminder_message: "",
                reminder_note: "",
                payment_type: -1,
                payment_type_object: {},
                paymentTypes: [],
                credit_card_name_on_card: "",
                credit_card_card_number: "",
                credit_card_expiry_month: "",
                credit_card_expiry_year: "",
                credit_card_ccv: "",
                credit_card_processor: "",
                year_options: [],
                save_card: 0,
                anet_transaction_id: "",
                anet_transaction_output: "",
                anet_transaction_name: "",
                payment_id: "",
                terminal: 0,
                terminals: [],
                payment_method_name: null,
                payment_method_id: null,
                show_payment_form: 0,
                export_type: 0,
                status: 7,
                signature_cc: null,
                receipt: 0,
                notes: null,
                acct_balance: null,
                is_add_payment_method: 1,
                original_payment_amount: null,
                rabies_docs: "",
                vaccine_docs: "",
                reminder_docs: "",
                soap_docs: "",
                wellness_docs: "",
                modalWindow: "#createPaymentModal",
                cardconnect_iframe_url: "",
                mytoken: "",
                myexpiry: "",
                myerror: "",
                cc_iframe_load: false,
                giframe_load: false,
                fund_id: null,
                deposit_to_fund: 0,
                pay_from_fund: 0,
                change_to_fund: 0,
                paynow_invoice_id: null,
                isSimulator: 0,
                testCardNumber: "",
                overpaidMsg: "",
                includeDeclined: false,
                defaultPaymentMethod: "card"
            },
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            showSignaturePad: true,
            showSaveCardOption: true,
            isPayNow: false,
            uuid: null,
            testNum: 0,
            stripeResponse: null,
            stripeTerminal: null,
            tempPostData: null,
            is3DS: false,
            uniqueId: null,
            isProcessing: false,
            showDontRefreshMsg: false,
            showPendingCubexItemAlert: false,
            sleepCheckInterval: null
        };
    },
    computed: {
        hideHeaderClose() {
            if (
                this.saving &&
                (_.get(this.$refs, "create.is_cc_terminal") ||
                    _.get(this.$refs, "create.is_cc_key_in") ||
                    _.get(this.$refs, "create.is_cc_card_in"))
            ) {
                return true;
            }

            return false;
        },
        selectedInvoices() {
            return this.payment_data.invoices;
        },
        selectedInvoicesId() {
            return this.selectedInvoices?.map(invoice => invoice.id) || [];
        },
        isHasUsersChooseInvoice() {
            return this.selectedInvoicesId
                ? !isEmpty(
                      this.$store.getters["billing/findUserChooseInvoices"](
                          this.selectedInvoicesId
                      )
                  )
                : false;
        },
        form_dirty() {
            return this.isProcessing;
        }
    },
    watch: {
        isHasUsersChooseInvoice(val) {
            if (val) {
                clearInterval(this.sleepCheckInterval);
            } else {
                this.checkForInactivity();
            }
        }
    },
    created() {
        let self = this;
        this.$on("change-page", page => {
            self.page = page;
        });
        this.$root.$on("stripe-reset-terminal", this.cancelStripeCollection);
        this.$root.$on(
            "capturing-stripe-terminal-payment",
            this.capturingStripeTerminal
        );
    },
    beforeDestroy() {
        clearInterval(this.sleepCheckInterval);
    },
    methods: {
        triggerEmitSocketInvoiceChanged() {
            this.emitSocketInvoiceChanged();
        },
        onModalShown() {
            this.uniqueId = this.uniqid();
            this.payment_data.uniqueId = this.uniqueId;

            /**
             * The Payment Modal is used multiple times across our app.
             * To avoid issues from several socket listeners triggering at once, we've registered the socket within this method.
             * Each Modal instance gets its own listener, preventing overlaps and ensuring correct functioning.
             * Keep this in mind when adjusting the code.
             */
            this.$socket.client.on("v-broadcast-all", params => {
                this.handlePostPayment(params);
            });
            this.onListenToVBroadcast();
            this.emitSocketInvoiceChanged();
        },
        onModalHidden() {
            /**
             * To prevent memory leaks and unnecessary processing, the listener is removed when the modal closes.
             */
            this.$socket.client.off("v-broadcast-all");
            this.offListenToVBroadcast();

            if (this.isPayNow) {
                this.showDontRefreshMsg = false;
                window.removeEventListener(
                    "beforeunload",
                    this.preventExitClientPayNow
                );
            }
        },
        beforeModalHidden() {
            clearInterval(this.sleepCheckInterval);

            this.payment_data.invoices = [];
            this.emitSocketInvoiceChanged([]);
        },
        handlePostPayment(params) {
            let {
                action,
                businessId,
                userId,
                message,
                s3_uri,
                uniqueId
            } = params;

            if (businessId !== this.$root.setting.business_id) {
                return;
            }
            if (userId !== this.$root.currentActor.id) {
                return;
            }
            if (uniqueId !== this.uniqueId) {
                return;
            }

            const selectedInvoiceIds = this.payment_data.invoices.map(
                invoice => invoice.id
            );

            switch (action) {
                case "payment:open:document":
                    if (s3_uri) {
                        window.open(s3_uri, "_blank"); // open pdf
                    }
                    break;

                case "payment:refresh:success":
                    this.emitSocketInvoicePaid(selectedInvoiceIds);
                    this.loading = false;
                    this.saving = false;
                    this.cancelling = false;
                    this.showDontRefreshMsg = false;
                    this.$emit("reload");
                    this.$refs.createPaymentModal.hide();
                    break;

                case "payment:refresh:fail":
                    this.loading = false;
                    this.saving = false;
                    this.cancelling = false;
                    this.showDontRefreshMsg = false;
                    this._message(message, "warning");
                    break;
            }
        },
        open() {
            this.datePickerOptions.format = this.getDateFormat();

            this.page = "create";
            this.payment_data.staff = this.$root.currentActor;

            this._getPaymentTypes(this.payment_data);
            this._getTerminals(this.payment_data);

            if (
                this.invoice?.id &&
                this._isExtensionEnabled(EXTENSIONS.CODE.CODE_CUBEX)
            ) {
                this.getPendingCubexItem(this.invoice?.id);
            }

            this.$refs.createPaymentModal.show();

            // generate uuid for duplication checking
            this.uuid = uuidv4();
            this.setSocketPaymentModalId(); // Id to be used for the socket invoice payment
            this.$nextTick(() => {
                this.client ? this.setClient() : null;
                this.invoice ? this.setInvoice() : null;
                // To handle multiple payment modal been opened at the same time
                this.joinPaymentInvoice(
                    null,
                    !joinPaymentInvoiceSocket.WITHAWAIT,
                    joinPaymentInvoiceSocket.ISFROMPAYMENTMODAL
                );

                // Clear any existing interval before starting a new one
                if (this.sleepCheckInterval) {
                    clearInterval(this.sleepCheckInterval);
                }

                this.checkForInactivity();
            });
        },
        checkForInactivity() {
            let last = new Date().getTime();
            let monoLast = performance.now();
            this.sleepCheckInterval = setInterval(() => {
                const now = new Date().getTime();
                const monoNow = performance.now();

                const delta = now - last;
                const monoDelta = monoNow - monoLast;

                if (delta - monoDelta > 40000 || delta > 40000) {
                    // close if inactivity is too long
                    this.close();
                }
                last = now;
                monoLast = monoNow;
            }, 1000);
        },
        isPaymentModalShowing() {
            let modalEl = document.getElementById("createPaymentModal");
            if (modalEl) {
                return modalEl.classList.contains("show");
            }
            return false;
        },
        updateData(details) {
            merge(this.payment_data, details);
        },
        async openPayNow(paymentData = {}) {
            if (paymentData.creditCardProcessor === "GRAVITY") {
                this.payment_data.payNowGravityStep = 1;
                this.payment_data.giframe_load = false;
                this.loading = false;
            } else {
                this.loading = true;
            }

            this.page = "payment";
            this.showSignaturePad = false;
            this.isPayNow = true;
            this.showSaveCardOption = false;

            if (paymentData.amount > 60 && paymentData.amount < 10000) {
                try {
                    let bnpl = await PaymentService.getBnplPaymentType({
                        businessId: paymentData.businessId
                            ? paymentData.businessId
                            : this.$root.setting.business_id,
                        bnplType: PaymentType.TYPE.NAME_BNPL_SUNBIT
                    });
                    if (bnpl.message.code === 200) {
                        this.page = "payment-selection";
                        this.payment_data.bnplPaymentType = bnpl.resources;
                    }
                } catch (error) {
                    console.error("Error fetching BNPL payment type:", error);
                }
            }

            this.payment_data.isFixedAmount = false;
            this.payment_data.myerror = "";
            this.payment_data.overpaidMsg = "";
            this.payment_data.currency_symbol = paymentData.currency;
            this.payment_data.payment_amount = paymentData.amount;
            this.payment_data.payment_amount_max = paymentData.amount;
            this.payment_data.show_payment_form = 1;
            this.payment_data.credit_card_processor =
                paymentData.creditCardProcessor;
            this.payment_data.cardconnect_iframe_url =
                paymentData.cardConnectUrl;
            this.payment_data.cc_iframe_load = false;
            this.payment_data.skip_payment = paymentData.skip_payment ?? false;

            this.payment_data.client_id = paymentData.clientId;
            this.payment_data.business_id = paymentData.businessId;
            this.payment_data.to_date = paymentData.toDate;
            this.payment_data.payment_type_id = paymentData.paymentTypeId;
            this.payment_data.payment_type_name = paymentData.paymentTypeName;
            this.payment_data.paynow_invoice_id = paymentData.invoiceId;
            this.payment_data.isPayNow = true;
            this.payment_data.trans_type = "payment";

            this.$refs.createPaymentModal.show();
        },
        setClient() {
            let fullName =
                this.client.firstname +
                " " +
                (this.client.lastName || this.client.lastname);
            this.payment_data.client = this.client;
            this.payment_data.client.fullName = fullName;
            this.payment_data.client.label = fullName;
            this.payment_data.client_id = this.client.id;
            this.payment_data.client_email = this.client.email;
            this.payment_data.client_fax = this.client.fax;
        },
        setInvoice() {
            this.payment_data.invoices.push(this.invoice);
        },
        async saveCreditCard() {
            let self = this;
            self.loading = true;
            self.saving = true;
            self.isProcessing = true;
            if (!window.paymentProcessingBanner) {
                this.showPaymentProcessingMessage();
            }
            //update metadata and insert save card to receive it in webhook for stripe
            const save_card = self.payment_data.save_card == 1;
            if (
                save_card &&
                this.payment_data.credit_card_processor === "STRIPE"
            ) {
                try {
                    let updateMetadata = await PaymentService.updateSaveCard(
                        self.payment_data.stripe.clientSecret.split(
                            "_secret"
                        )[0],
                        {
                            input_metadata: {
                                save_card: save_card
                            }
                        }
                    );
                    if (updateMetadata.code !== 200) {
                        self._message("Failed to save card", "danger");
                        self.loading = false;
                        self.saving = false;
                        return;
                    }
                } catch (error) {
                    self._message("Failed to save card", "danger");
                    self.loading = false;
                    self.saving = false;
                    return;
                }
            }

            return self.$refs.payment
                .pay_quickadd(self.payment_data)
                .then(async response => {
                    const sleep = m => new Promise(r => setTimeout(r, m));

                    if (response && response.state !== 1) {
                        if (
                            this.payment_data.credit_card_processor ===
                                "CCONNECT" &&
                            this.payment_data.show_payment_form === 1
                        ) {
                            await sleep(4000);

                            if (
                                this.payment_data.mytoken !== "" &&
                                this.payment_data.myexpiry !== ""
                            ) {
                                return this.save(response);
                            } else {
                                let err = this.payment_data.myerror;

                                if (err !== "") {
                                    if (err === "Invalid Account Number") {
                                        this._message(
                                            "Invalid card number",
                                            "danger"
                                        );
                                    }

                                    if (err === "Invalid CVV") {
                                        this._message(
                                            "Invalid security code",
                                            "danger"
                                        );
                                    }

                                    if (err === "Invalid Expiry") {
                                        this._message(
                                            "Invalid expiration date",
                                            "danger"
                                        );
                                    }

                                    this.loading = false;
                                    this.isProcessing = false;
                                    this.closePaymentProcessingMessage();
                                }
                            }
                        } else if (
                            this.payment_data.credit_card_processor ===
                                "STRIPE" &&
                            this.payment_data.show_payment_form === 1
                        ) {
                            self.stripeResponse = response;
                            // stripe/terminal/capture/

                            let result = await this._captureStripeTerminalPayment(
                                response.uniqueTransId
                            );

                            let message = result.data.response.message;
                            if (message.code == 200) {
                                let status = message.payment_intent.status;

                                switch (status) {
                                    case "succeeded":
                                        self._message(
                                            "Payment saved",
                                            "success"
                                        );
                                        break;
                                    case "processing":
                                        self._message(
                                            "Your payment is processing.",
                                            "warning"
                                        );
                                        break;
                                    default:
                                        self._message(
                                            "Something went wrong.",
                                            "danger"
                                        );
                                        break;
                                }
                            }
                            // waiting for socket to trigger from backend
                            // self.save();
                        } else {
                            return self.save(response);
                        }
                    } else {
                        return response;
                    }
                });
        },
        resetStripeTerminal() {
            // comment out below code, so we can revert back to Stripe's javascript API if needed
            // this.stripeTerminal.cancelCollectPaymentMethod();
            this.cancelling = true;
            this._cancelStripeTerminal(this.stripeTerminal);
            this.stripeTerminal = null;
        },
        cancelStripeCollection(stripeTerminal) {
            this.stripeTerminal = stripeTerminal;
        },
        capturingStripeTerminal() {
            this.stripeTerminal = null;
            this.cancelling = false;
        },
        shown() {
            // reset all data
            this.page = "checkout";
        },
        next() {
            let self = this;

            if (self.page === "create") {
                self.$refs.create.$validator
                    .validateAll()
                    .then(async result => {
                        if (result) {
                            if (!_.get(this.$refs, "create.is_stripe_acss")) {
                                self.payment_data.show_payment_form = 1;
                                self.payment_data.credit_card_name_on_card = get(
                                    self,
                                    "payment_data.client.label"
                                );
                                self.page = "payment";

                                if (
                                    self.payment_data.credit_card_processor ===
                                        "CCONNECT" &&
                                    !self.payment_data.cc_iframe_load
                                ) {
                                    self.loading = true;
                                }
                            } else {
                                // load iframe for acss debit stripe
                                self.loading = true;
                                let metadata = self._generateMetadata(
                                    {
                                        ...self.payment_data,
                                        userId: self.$root.currentActor.id
                                    },
                                    self.payment_data.is_census
                                );
                                self.$http
                                    .post(
                                        process.env.BARRAMUNDI +
                                            "payment/stripe/secret",
                                        {
                                            amount:
                                                self.payment_data
                                                    .payment_amount,
                                            client_id:
                                                self.payment_data.client_id,
                                            trans_type: "acss_debit",
                                            input_metadata: metadata,
                                            business_id:
                                                self.payment_data.business_id
                                        }
                                    )
                                    .then(function (response) {
                                        if (
                                            response.data.response.client_secret
                                        ) {
                                            let clientSecret =
                                                response.data.response
                                                    .client_secret;
                                            // eslint-disable-next-line no-undef
                                            let stripe = Stripe(
                                                _.get(
                                                    self,
                                                    "$root.cc_extension.STRIPE_PUBLIC_KEY",
                                                    ""
                                                ),
                                                {
                                                    stripeAccount: _.get(
                                                        self,
                                                        "$root.cc_extension.STRIPE_ACCOUNT_ID",
                                                        ""
                                                    )
                                                }
                                            );

                                            stripe
                                                .confirmAcssDebitPayment(
                                                    clientSecret,
                                                    {
                                                        payment_method: {
                                                            billing_details: {
                                                                name:
                                                                    self
                                                                        .payment_data
                                                                        .client
                                                                        .fullName,
                                                                email:
                                                                    self
                                                                        .payment_data
                                                                        .client
                                                                        .email
                                                            }
                                                        }
                                                    }
                                                )
                                                .then(function (result) {
                                                    if (result.error) {
                                                        self.loading = false;
                                                        self._message(
                                                            result.error.code ==
                                                                "parameter_missing"
                                                                ? "Requires client email address"
                                                                : result.error
                                                                      .message,
                                                            "danger"
                                                        );
                                                    } else {
                                                        self.stripeResponse = {
                                                            uniqueTransId:
                                                                result
                                                                    .paymentIntent
                                                                    .id,
                                                            externalTransactionId:
                                                                result
                                                                    .paymentIntent
                                                                    .payment_method
                                                        };
                                                    }
                                                });
                                        }
                                    });
                                //
                            }
                        }
                    });
            }
        },
        showCreditCardDialog() {
            let self = this;
            if (self.page === "create") {
                self.$refs.create.$validator.validateAll().then(result => {
                    if (result) {
                        self.payment_data.credit_card_name_on_card = get(
                            self,
                            "payment_data.client.label"
                        );
                        self.payment_data.show_payment_form = 0;
                        self.page = "payment";
                    }
                });
            }
        },
        back() {
            if (this.page === "payment") {
                this.page = "create";
                this.title = "New Payment";
            }
        },
        close() {
            clearInterval(this.sleepCheckInterval);
            this.$refs.createPaymentModal.hide();
        },
        async confirmPaymentStripe() {
            let self = this;
            self.loading = true;
            await self.$refs.payment.$refs.stripeElements
                .confirmPaymentStripe()
                .then(response => {
                    if (response.code == 200) {
                        self.stripeResponse = {
                            uniqueTransId: response.id,
                            externalTransactionId: response.payment_method
                        };
                        self.payment_data.uniqueTransId = response.id;
                        self.savePayNow();
                    } else {
                        this.loading = false;
                        this.payment_data.myerror = response.error.message;
                    }
                });
        },
        async savePayNow() {
            try {
                this.payment_data.myerror = "";
                this.loading = true;

                if (this.payment_data.credit_card_processor === "CCONNECT") {
                    const sleep = m => new Promise(r => setTimeout(r, m));
                    await sleep(4000);
                }

                let postData = {
                    business_id: this.payment_data.business_id,
                    customer_id: this.payment_data.client_id,
                    amount: this.payment_data.payment_amount,
                    processor: this.payment_data.credit_card_processor,
                    payment_type_id: this.payment_data.payment_type_id,
                    payment_type: this.payment_data.payment_type_name,
                    card_number: this.payment_data.mytoken,
                    expiration: this.payment_data.myexpiry,
                    external_id: this.payment_data.externalTransactionId,
                    transaction_id: this.payment_data.uniqueTransId,
                    is_statement: "1",
                    to: this.payment_data.to_date,
                    stripe: this.stripeResponse
                };

                if (this.payment_data.paynow_invoice_id) {
                    postData.invoice_id = this.payment_data.paynow_invoice_id;
                    postData.is_invoice = "1";
                    delete postData.is_statement;
                }

                const res = await this.$http.post(
                    `${process.env.BARRAMUNDI}payment/charge-client-online`,
                    postData
                );

                if (res.data.response.message.code === 200) {
                    this.$refs.createPaymentModal.hide();

                    this.$emit("on-success", {
                        balance: res.data.response.balance
                    });
                } else {
                    throw new Error(res.data.response.message.description);
                }
            } catch (e) {
                this.loading = false;
                this.payment_data.myerror = e.message;
            }
        },
        async checkInvoiceStatus() {
            this.loading = true; // prevent multiple clicks

            if (this.isPayNow) {
                this.showDontRefreshMsg = true;
                window.addEventListener(
                    "beforeunload",
                    this.preventExitClientPayNow
                );
            }

            const invoiceIds = filter(this.payment_data.invoices, {
                is_invoice: true
            }).map(inv => inv.id);

            if (this.payment_data.paynow_invoice_id) {
                invoiceIds.push(this.payment_data.paynow_invoice_id);
            }

            if (invoiceIds.length <= 0) {
                this.loading = false;
                this.proceedSave();
                return;
            }

            try {
                let response = await PaymentService.checkInvoiceStatus({
                    invoices: invoiceIds
                });

                if (response.code == 200) {
                    this.loading = false;
                    const paidInvoices = filter(response.resources, {
                        status: INVOICE_STATUS_PAID
                    });

                    if (paidInvoices.length > 0) {
                        this.$refs["credit-convert-confirmation"].open(
                            paidInvoices
                        );
                    } else {
                        this.proceedSave();
                    }
                } else {
                    throw "ERROR";
                }
            } catch (error) {
                this.loading = false;
                this.saving = false;
                this.showDontRefreshMsg = false;
                this._message("ERROR: Something wrong!", "danger");

                if (this.isPayNow) {
                    this.payment_data.myerror = "ERROR: Something wrong!";
                }
            }
        },
        notConfirmed() {
            this.loading = false;
            this.saving = false;
        },
        async proceedSaveByPaymentMethod() {
            if (this.payment_data.credit_card_processor === "GRAVITY") {
                this.payNowProceedGravity();
            } else if (this.payment_data.credit_card_processor == "STRIPE") {
                if (
                    this.payment_data?.defaultPaymentMethod == "pay-over-time"
                ) {
                    let self = this;
                    self.loading = true;
                    await self.$refs.payment.$refs.bnplElements.confirmPaymentStripe();
                } else {
                    this.confirmPaymentStripe();
                }
            } else if (this.payment_data.credit_card_processor !== "GRAVITY") {
                this.savePayNow();
            }
        },
        async proceedSave() {
            if (this.isPayNow && this.page === "payment") {
                // NOTE: no need amount validation as the amount is not editable
                if (!this.payment_data.isFixedAmount) {
                    this.$refs.payment.$validator
                        .validateAll()
                        .then(async validate => {
                            if (validate) {
                                this.payment_data.myerror = "";
                                this.proceedSaveByPaymentMethod();
                            } else {
                                this.showDontRefreshMsg = false;
                                this.payment_data.myerror =
                                    "ERROR: Please enter a valid amount";
                            }
                        });
                } else {
                    this.payment_data.myerror = "";
                    this.proceedSaveByPaymentMethod();
                }
            } else {
                if (
                    this.page == "create" &&
                    get(
                        this.payment_data,
                        "payment_type_object.name",
                        ""
                    ).includes("Keyed-in")
                ) {
                    this.next();
                } else if (
                    this.page == "create" &&
                    get(
                        this.payment_data,
                        "payment_type_object.name",
                        ""
                    ).includes("ACSS Debit") &&
                    _.get(this.$refs, "create.is_stripe_acss")
                ) {
                    this.next();
                } else if (
                    this.page == "create" &&
                    get(this.$refs, "create.is_cc_card_in")
                ) {
                    this.showCreditCardDialog();
                } else {
                    this.save();
                }
            }
        },
        async save(params = null) {
            let self = this;
            let valid = true;
            self.loading = true;
            self.saving = true;
            self.cancelling = false;
            self.isProcessing = true;
            if (!window.paymentProcessingBanner) {
                self.showPaymentProcessingMessage();
            }

            let invoices_list_param = self.payment_data.invoices
                ? map(self.payment_data.invoices, element => element.id).join(
                      ","
                  )
                : "";

            let credits_param = self.payment_data.credits.map(
                element => element.id
            );

            let documents_param = self.payment_data.documents.map(
                element => element.id
            );

            if (self.page === "create") {
                valid = await self.$refs.create.$validator.validateAll();
                if (!valid) {
                    self.loading = false;
                    self.isProcessing = false;
                    self.closePaymentProcessingMessage();
                    return false;
                }
            }

            // process stripe payment terminal
            if (
                self._checkPaymentName(
                    self.payment_data.payment_type_object.name,
                    "terminal",
                    "stripe"
                ) &&
                self.payment_data.terminal != 0
            ) {
                let terminalResponse = null;
                let metadata = self._generateMetadata({
                    ...self.payment_data,
                    uniqueId: this.uniqueId
                });

                this.showPaymentProcessingMessage();

                // if this is simulator payment, we use the Javascript library API
                if (self.payment_data.isSimulator) {
                    terminalResponse = await self._processStripeTerminal(
                        self.payment_data,
                        metadata
                    );
                } else {
                    terminalResponse = await self._processServerDrivenStripeTerminal(
                        self.payment_data,
                        metadata
                    );
                }

                this.closePaymentProcessingMessage();

                if (!terminalResponse) {
                    self.loading = false;
                    self.stripeTerminal = null;
                    return false;
                }

                if (terminalResponse.state && terminalResponse.state != 0) {
                    self.loading = false;
                    self.stripeTerminal = null;
                    self._message(terminalResponse.message, "danger");
                    return false;
                } else {
                    self.stripeResponse = {
                        uniqueTransId:
                            terminalResponse.message.payment_intent.id
                    };
                    self.payment_data.uniqueTransId =
                        terminalResponse.message.payment_intent.id;
                }

                return; // handle post-payment process with socket, see `sockets` (in this file)
            }

            let post = {
                id: self.payment_data.id,
                cid: self.payment_data.client
                    ? self.payment_data.client.id
                    : null,
                balance: self.payment_data.invoice_amount,
                write_off_amount: 0,
                credit_amount: null,
                isShortcut: 1,
                invoice_payment_total: 0,
                invoice_credit_total: 0,
                invoice_total: self.payment_data.invoice_amount,
                cash_amount: 0,
                timestamp: self.payment_data.start.format(
                    self.getDateFormat() + " h:mm A"
                ),
                credit_applied: 0,
                hchange: self.payment_data.change,
                mobile: null,
                fax: null,
                overpaid_amount: null,
                sms_status: 1,
                fax_status: null,
                flag: null,
                isReturn: null,
                start: self.payment_data.start.format(self.getDateFormat()),
                action: "New",
                invoices_list: self.payment_data.deposit_to_fund
                    ? null
                    : invoices_list_param,
                client_profile: null,
                cash_ids: self.payment_data.payment_type,
                payment_method_id: get(
                    self,
                    "payment_data.payment_method_name.id",
                    get(
                        self,
                        "payment_data.payment_method_name.payment_method_id"
                    )
                ),
                is_add_payment_method: self.payment_data.is_add_payment_method,
                swipe_unique: self.payment_data.swipe_unique,
                signature_cc: self.payment_data.signature_cc,
                // unique_id: this.uniqid(),
                unique_id: this.uniqueId,
                payment_date: self.payment_data.start.format(
                    self.getDateFormat()
                ),
                payment_time: self.payment_data.start.format("h:mm A"),
                client: self.payment_data.client
                    ? self.payment_data.client.fullName
                    : null,
                acct_balance: self.payment_data.acct_balance,
                amount: self.payment_data.payment_amount,
                original_payment_amount:
                    self.payment_data.original_payment_amount,
                type: self.payment_data.payment_type,
                payment_method_name: get(
                    self,
                    "payment_data.payment_method_name.label",
                    get(self, "payment_data.payment_method_name", "")
                ),
                stripeToken: get(self, "payment_data.stripeToken", null),
                terminal: get(self, "payment_data.terminal", 0),
                invoice: self.payment_data.deposit_to_fund
                    ? null
                    : map(self.payment_data.invoices, element => element.id),
                default_invoice_id: 0,
                total_invoice_amount: self.payment_data.invoice_amount,
                change: self.payment_data.change,
                receipt: self.payment_data.receipt,
                reference: self.payment_data.notes,
                credits: credits_param,
                documents: documents_param,
                rabies_docs: self.payment_data.rabies_docs,
                vaccine_docs: self.payment_data.vaccine_docs,
                reminder_docs: self.payment_data.reminder_docs,
                soap_docs: self.payment_data.soap_docs,
                wellness_docs: self.payment_data.wellness_docs,
                export_type: self.payment_data.export_type,
                export_message: self.payment_data.export_message,
                mytoken: self.payment_data.mytoken,
                myexpiry: self.payment_data.myexpiry,
                save_card: self.payment_data.save_card,
                name_on_card: self.payment_data.credit_card_name_on_card,
                fund_id: self.isFundIdNeeded()
                    ? self.payment_data.fund_id
                    : null,
                deposit_to_fund: self.payment_data.deposit_to_fund,
                pay_from_fund: self.payment_data.pay_from_fund,
                change_to_fund: self.payment_data.change_to_fund,
                stripe: self.stripeResponse,
                include_declined: self.payment_data.includeDeclined
            };

            /**
             * APPLYING CREDIT ONLY
             */
            if (self.payment_data.payment_type === "CREDIT_ONLY") {
                post.amount = 0;
            }

            // append uuid
            post.uuid = this.uuid;

            // -- merge if contain card_number
            if (
                params &&
                self.payment_data.payment_type_object.name.includes("Keyed-in")
            ) {
                post = merge(post, params);
            }

            if (
                self.payment_data.credit_card_processor === "GRAVITY" &&
                self.payment_data.payment_type_object &&
                self.payment_data.payment_type_object.name ===
                    "Credit Card Keyed-in (Gravity)"
            ) {
                post.gravity = {
                    uniqueTransId: self.payment_data.uniqueTransId,
                    accountCardType: self.payment_data.accountCardType,
                    accountExpiryDate: self.payment_data.accountExpiryDate,
                    last4digit: self.payment_data.last4digit,
                    externalTransactionId:
                        self.payment_data.externalTransactionId
                };
            }
            if (
                self.payment_data.credit_card_processor === "STRIPE" &&
                self.payment_data.payment_type_object.name ===
                    PaymentType.TYPE.NAME_STRIPE_CARD_ON_FILE
            ) {
                let metadata = self._generateMetadata(
                    {
                        ...self.payment_data,
                        userId: self.$root.currentActor.id
                    },
                    self.payment_data.is_census
                );
                await self
                    ._createPaymentIntentStripe({
                        amount: Number(post.amount),
                        client_id: post.cid,
                        trans_type: "card_on_file",
                        payment_method_id: post.payment_method_id,
                        metadata: metadata,
                        business_id: metadata.business_id
                    })
                    .then(async function (response) {
                        if (response.message.code == 200) {
                            if (
                                response.payment.status == "requires_action" &&
                                response.payment.next_action
                            ) {
                                self.is3DS = true;
                                self.tempPostData = post;
                                self.$refs.paymentAuthentication.open(
                                    response.payment.next_action
                                );
                            } else if (
                                response.payment.status == "succeeded" &&
                                response.transaction_id
                            ) {
                                self.is3DS = false;
                                post.stripe = {
                                    uniqueTransId: response.transaction_id,
                                    externalTransactionId:
                                        response.payment.payment_method
                                };
                                let result = await self._captureStripeTerminalPayment(
                                    response.transaction_id
                                );

                                let message = result.data.response.message;
                                if (message.code == 200) {
                                    let status = message.payment_intent.status;

                                    switch (status) {
                                        case "succeeded":
                                            self._message(
                                                "Payment saved",
                                                "success"
                                            );
                                            break;
                                        case "processing":
                                            self._message(
                                                "Your payment is processing.",
                                                "warning"
                                            );
                                            break;
                                        default:
                                            self._message(
                                                "Something went wrong.",
                                                "danger"
                                            );
                                            break;
                                    }
                                }
                            }
                        } else {
                            self.loading = false;
                            valid = false;
                            self._message(
                                response.message.description,
                                "danger"
                            );
                            return false;
                        }
                    });
                return;
            }

            if (!self.is3DS && valid) {
                const response = await this.$http.post(
                    process.env.APPS + "index.php/billing/payment/save",
                    $.param(post)
                );

                let data = response.data;

                // eslint-disable-next-line eqeqeq
                if (data.state == 1) {
                    self.loading = false;
                    self.saving = false;
                    self.isProcessing = false;
                    self.closePaymentProcessingMessage();
                    self._message(data.message, "warning");
                } else {
                    self._message(data.message);

                    if (data.flag == 0 || data.flag == 2) {
                        if (
                            data.documents &&
                            some(data.documents.document_uri)
                        ) {
                            data.documents.document_uri.map(doc => {
                                self._redirect(doc, true, 500);
                            });
                        }
                    } else {
                        if (data.refresh == 1) {
                            //set cookie for views\staff\billing\invoice\invoice\index.php
                            if (data.payment) {
                                this.$cookie(
                                    "billing.invoice.payment_id",
                                    data.payment
                                );
                            }

                            this.$cookie(
                                "billing.invoice.active_tab",
                                "payment"
                            );
                            location.reload(true);
                        } else {
                            if (data.pdf == 1) {
                                //print pdf
                                this._receiptPrint(data.payment);
                            }
                            //refresh summary
                            // SUMMARY.refresh;
                        }
                    }

                    this.emitSocketInvoicePaid(post.invoice);
                    this.$emit("reload");

                    self.$refs.createPaymentModal.hide();
                }

                self.isProcessing = false;
                self.closePaymentProcessingMessage();
                return data;
            }
        },
        isFundIdNeeded() {
            let details = this.payment_data;
            return (
                details.deposit_to_fund ||
                details.pay_from_fund ||
                details.change_to_fund
            );
        },
        verifyGravityPayment() {
            let self = this;
            var gravityData = {
                uniqueTransId: self.payment_data.uniqueTransId,
                externalTransactionId: self.payment_data.externalTransactionId
            };

            self.$http
                .post(process.env.BARRAMUNDI + "payment/verify-transaction", {
                    gravityData: gravityData
                })
                .then(function (response) {
                    if (response.data.response.success) {
                        self.saveCreditCard();
                    } else {
                        self._message(
                            "Payment failed. Please try again.",
                            "danger"
                        );
                        self.$refs.payment.callGravityIFrame(
                            self.payment_data.gravity_button
                        );
                    }
                });
        },
        cancelOperation() {
            let self = this;
            self.cancelling = true;

            self.$http
                .post(process.env.BARRAMUNDI + "payment/cancel-operation", {
                    hsn: self.payment_data.terminal,
                    payment_type: "Credit Card On Terminal (Gravity)"
                })
                .then(function (response) {
                    /*if (response.data.response.message.code == 200) {
                        self._message(
                            response.data.response.message.description
                        );
                    } else {
                        self._message(
                            response.data.response.message.description,
                            "danger"
                        );
                    }*/

                    self.loading = false;
                    self.saving = false;
                    self.cancelling = false;
                });
        },
        payNowProceedGravity() {
            this.loading = true;
            this.payment_data.payNowGravityStep = 2;
            this.$refs.payment.callGravityIFrame(
                this.payment_data.gravity_button
            );
        },
        disabledSaveButton(isDisabled) {
            let self = this;
            if (isDisabled) {
                self.isDisabledButton = true;
            } else {
                self.isDisabledButton = false;
            }
        },
        reloadPaymentIntent(isLoading) {
            let self = this;
            if (isLoading) {
                self.isIntentLoading = true;
            } else {
                self.isIntentLoading = false;
            }
        },
        async onComplete3ds(data) {
            let self = this;
            if (data.error) {
                self.loading = false;
                self.saving = false;
                self._message("Payment Error");

                await self._cancelTerminalPaymentIntentStripe(
                    data.paymentIntent.id
                );
            } else {
                if (data.paymentIntent.status === "succeeded") {
                    self.tempPostData.stripe = {
                        uniqueTransId: data.paymentIntent.id,
                        externalTransactionId: data.paymentIntent.payment_method
                    };
                    self._message("Payment Saved");
                    self.$refs.createPaymentModal.hide();
                } else {
                    self.saving = false;
                    self.loading = false;
                    self._message(
                        "Authentication failed, please enter another payment method"
                    );

                    await self._cancelTerminalPaymentIntentStripe(
                        data.paymentIntent.id
                    );
                }
            }
        },
        async flagHandler() {
            let self = this;

            const response = await this.$http.post(
                process.env.APPS + "index.php/billing/payment/save",
                $.param(self.tempPostData)
            );

            let data = response.data;
            self.flag = data;

            // eslint-disable-next-line eqeqeq
            if (data.state == 1) {
                self.loading = false;
                self.saving = false;
                self._message(data.message, "warning");
            } else {
                self._message(data.message);

                if (data.flag == 0 || data.flag == 2) {
                    if (data.documents && some(data.documents.document_uri)) {
                        data.documents.document_uri.map(doc => {
                            self._redirect(doc, true, 500);
                        });
                    }
                } else {
                    if (data.refresh == 1) {
                        //set cookie for views\staff\billing\invoice\invoice\index.php
                        if (data.payment) {
                            this.$cookie(
                                "billing.invoice.payment_id",
                                data.payment
                            );
                        }

                        this.$cookie("billing.invoice.active_tab", "payment");
                        location.reload(true);
                    } else {
                        if (data.pdf == 1) {
                            //print pdf
                            this._receiptPrint(data.payment);
                        }
                        //refresh summary
                        // SUMMARY.refresh;
                    }
                }

                this.$emit("reload");
            }
        },
        preventExitClientPayNow(event) {
            event.preventDefault();
            event.returnValue = "";
        },
        getPendingCubexItem(invoiceId) {
            CubexService.getPendingCubexItem(invoiceId).then(response => {
                if (response.resources.length > 0) {
                    this.showPendingCubexItemAlert = true;
                }
            });
        }
    }
};
</script>

<style>
/* to eliminiate the backdrop as the approval modal open on top of this modal */
#credit-convert-confirmation___BV_modal_backdrop_ {
    opacity: 0.5 !important;
}
</style>
